
export { checkIsApp } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/consumer/data-access/src/lib/utils/utils.ts"